import React from "react";
import BlogFortyThree from "../component/BlogFortyThree";

function BlogFortyThreeContainer() {
  return <BlogFortyThree />;
}

export default BlogFortyThreeContainer;
